module.exports = __webpack_public_path__ + "img/admin-a2.bd92e093.png";